import React from "react";

import "./RequiredIndicator.scss";

const RequiredIndicator = () => <em className="required-indicator">*</em>;

export default RequiredIndicator;
